module.exports = __webpack_public_path__ + "static/media/PR.2fe9af3a.png";